// src/pages/Users/Produits/components/ProductCard.jsx

import React from "react";
import {
  FaExternalLinkAlt,
  FaLaptopCode,
  FaRocket,
} from "react-icons/fa";

import {
  ensureHttp,
  getProductImage,
  hostLabel,
  parseDemoLinks,
  FALLBACK_PRODUCT_IMG,
} from "../utils/productsUtils";

function onImgError(event) {
  if (event?.currentTarget) {
    event.currentTarget.src = FALLBACK_PRODUCT_IMG;
  }
}

export default function ProductCard({ app }) {
  const { nom_app, description_app, lien_url_app } = app || {};

  const imgSrc = getProductImage(app);
  const demoLinks = parseDemoLinks(lien_url_app);

  return (
    <article className="group overflow-hidden rounded-[1.75rem] border border-slate-200 bg-white shadow-sm transition hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-950/10 dark:border-slate-800 dark:bg-slate-900">
      <div className="relative overflow-hidden bg-slate-100 dark:bg-slate-950">
        <div className="aspect-[16/10] w-full">
          <img
            src={imgSrc}
            alt={nom_app || "Application web"}
            className="h-full w-full object-contain p-3 transition duration-500 group-hover:scale-[1.04]"
            loading="lazy"
            onError={onImgError}
          />
        </div>

        <div className="absolute left-3 top-3">
          <span className="inline-flex items-center gap-2 rounded-full bg-slate-950/80 px-3 py-1 text-[11px] font-bold uppercase text-white backdrop-blur">
            <FaLaptopCode />
            Application
          </span>
        </div>
      </div>

      <div className="flex min-h-[260px] flex-col p-4">
        <div className="flex-1">
          <h3 className="line-clamp-2 text-lg font-bold leading-snug text-slate-950 dark:text-white">
            {nom_app || "Application sans nom"}
          </h3>

          <p className="mt-2 line-clamp-5 text-sm leading-6 text-slate-600 dark:text-slate-300">
            {description_app || "Description non renseignée."}
          </p>
        </div>

        <div className="mt-4">
          {demoLinks.length === 0 && (
            <span className="inline-flex min-h-11 w-full items-center justify-center rounded-2xl bg-slate-100 px-4 text-sm font-bold text-slate-400 dark:bg-slate-800">
              Lien non disponible
            </span>
          )}

          {demoLinks.length === 1 && (
            <a
              href={ensureHttp(demoLinks[0])}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 text-sm font-bold text-white transition hover:bg-slate-800 active:scale-95 dark:bg-white dark:text-slate-950 dark:hover:bg-slate-200"
            >
              <FaRocket />
              Découvrir
              <FaExternalLinkAlt className="text-xs opacity-70" />
            </a>
          )}

          {demoLinks.length > 1 && (
            <div className="space-y-2">
              {demoLinks.slice(0, 3).map((url, index) => (
                <a
                  key={`${url}-${index}`}
                  href={ensureHttp(url)}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={url}
                  className="inline-flex min-h-10 w-full items-center justify-center gap-2 rounded-2xl bg-slate-100 px-3 text-xs font-bold text-slate-700 transition hover:bg-slate-200 active:scale-95 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                >
                  {hostLabel(url, index)}
                  <FaExternalLinkAlt className="text-[10px] opacity-70" />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </article>
  );
}